import axios from "../api";

// GET APPROVAL STATS
export const getApprovalStatsAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/approval/stats")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error("ERROR:", error);
        reject(error);
      });
  });
};

// LIST APPROVAL REQUESTS
export const listApprovalRequestsAction = async (
  page,
  pageSize,
  status = "PENDING",
  entity = ""
) => {
  let apiUrl = `/api/approval?page=${page}&pageSize=${pageSize}&status=${status}`;

  if (entity) {
    apiUrl += `&entity=${entity}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error("ERROR:", error);
        reject(error);
      });
  });
};

// GET APPROVAL REQUEST BY ID
export const getApprovalRequestByIdAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/approval/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error("ERROR:", error);
        reject(error);
      });
  });
};

// APPROVE REQUEST
export const approveRequestAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/approval/${id}/approve`, {})
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error("ERROR:", error);
        reject(error);
      });
  });
};

// REJECT REQUEST
export const rejectRequestAction = async (
  id,
  reason = ""
) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/approval/${id}/reject`, {
        reason,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error("ERROR:", error);
        reject(error);
      });
  });
};